import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { bbitProdEnvironmentKey, IBbitOrganizationLegalIdentity } from '@bbitgmbh/bbit.utils';
import { BbitWebShopService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { DateTime } from 'luxon';
import { BehaviorSubject, map, share } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIcon, ReactiveFormsModule, FormsModule, RouterLink, AsyncPipe, I18nPipe],
})
export class FooterComponent implements OnInit {
  public identity = new BehaviorSubject<IBbitOrganizationLegalIdentity | undefined>(undefined);
  public currentYear = DateTime.now().toFormat('yyyy');

  public mailToLink = this.identity.asObservable().pipe(
    map((identity) => {
      if (!identity) {
        return '';
      }
      return `mailto:${identity.mainEMail}`;
    }),
    share(),
  );

  public phoneLink = this.identity.asObservable().pipe(
    map((identity) => {
      if (!identity) {
        return '';
      }
      return `tel:${identity.mainPhone?.replace(/\s/g, '')}`;
    }),
    share(),
  );

  constructor(
    public webShop: BbitWebShopService,
    private _website: BbitWebsiteService,
  ) {
    this.identity.next(this._website.getAuthMeta()?.environments?.[bbitProdEnvironmentKey]?.identity);
  }

  ngOnInit(): void {}
}
